import { UserAuthForm } from "./components/user-auth-form";
import { LogoInverted } from "@/authentication/components/logo";

export default function AuthenticationPage() {
  return (
    <>
      <div className="container relative h-screen flex-col items-center justify-center grid lg:max-w-none grid-cols-1 lg:grid-cols-2 lg:px-0">

        {/* Left side */}
        <div className="relative hidden h-full flex-col bg-muted px-8 pt-2 text-white lg:flex dark:border-r">
          <div className="absolute inset-0 bg-[#6B6397]" />
          <div className="relative z-20 flex items-center text-lg font-medium">
            <LogoInverted className="max-w-[180px] pt-6" />
          </div>
          <div className="relative z-20 my-auto w-[500px]">
            <h1 className="scroll-m-20 mb-6 text-5xl font-semibold tracking-tight text-[#ffffff] leading-[60px]">
              Compensation made simple
            </h1>
            <p className="text-lg font-light pt-4 text-[rgb(231,231,232)]">
              Create an account to start automating your sales compensation
              plans today.
            </p>
          </div>
        </div>

        {/* Right side */}
        <div className="lg:p-8">
          <div className="mx-auto flex w-full flex-col justify-center space-y-8 sm:w-[350px]">
            <div className="flex flex-col space-y-0 text-center">
              <h1>
                Log in to Revelate
              </h1>
              <p className="text-lg font-light text-muted-foreground">
                Enter your work email below.
              </p>
            </div>
            <UserAuthForm />
          </div>
        </div>
      </div>
    </>
  );
}
